// Class D
var D = function (selector, context) {
  return new D.fn.init(selector, context);
};

export default D;
